import { HttpContextToken } from "@angular/common/http";

/**
 * Set on a request whose caller shows its own error messages: its failures
 * reach the subscriber as the raw HttpErrorResponse instead of a generic
 * toast. Network failures and session expiry are still handled by the
 * interceptor.
 */
export const HANDLES_OWN_ERRORS = new HttpContextToken<boolean>(() => false);
